import { UserType } from '@ccmn/rhino';

export default UserType;
